import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalHeader } from "../ModalHeader";
import { Props } from "./ModalTurn.type";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useEffect, useState } from "react";
import { Autocomplete, Divider, Grid, MenuItem, Select, TextField, Typography } from "@mui/material";
import { ModalFooter } from "../ModalFooter";
import '../../../assets/styles/modals.scss';
import { ChargeService } from "@/service/services/Charge.service";
import { Loading } from "@/components/common/Loading";
import { BusinessAreaService } from "@/service/services/BusinessArea.service";
import { TurnService } from "@/service/services/Turn.service";

export const ModalTurns: React.FC<Props> = (props:any): JSX.Element => {

    const { open, closeModal, actionSelected, turn, onListTurns, clearState } = props;

    const [loading, setLoading] = useState<boolean>(false);

    const [data, setData] = useState({
        turn: turn?.turn || ""
    });

    const validateForm = (values) => {
        let errors: any = {};
        if(!values.turn) errors.turn = "descripcion requerido";
        return errors;
    }

    const onSubmit = async(values, {resetForm})  => {

        const formData = {
            turn: values.turn,
        }
        setLoading(true);
        if(turn && actionSelected=='edit'){
            const respEdit = await TurnService.editTurn(turn.id,formData)
            onListTurns && onListTurns();
            closeModal && closeModal();
        }else{
            //llamar al crear
            const respCreated = await TurnService.createTurn(formData)
            onListTurns && onListTurns();
            closeModal && closeModal();
        }
        setLoading(false);
    }

    return(
        <>
        {loading && <Loading/>}

        <Modal open={open} handleClose={closeModal} handle size="sm">
            <ModalHeader
                text={(turn && actionSelected=='edit') ? "Editar Giro de Empresa" : "Agregar Giro de Empresa"}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) =>{
                        return(
                            <form onSubmit={handleSubmit}>
                                <Grid container >
                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>Descripcion:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="turn"
                                            variant="standard"
                                            type="text" 
                                            name="turn"
                                            fullWidth
                                            value={values.turn}
                                            onChange={handleChange}
                                            placeholder="Nombre"
                                            error={errors.turn && touched.turn ? true : false}
                                        />
                                        </Grid>
                                    </Grid>

                                </Grid>
                                <Divider />
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={(turn && actionSelected=='edit') ? "ACTUALIZAR" : "REGISTRAR"}
                                    cancelText="CANCELAR" 
                                    onCancel={closeModal}
                                    onConfirm={handleSubmit}
                                    clearState={clearState}
                                />
                            </form>
                        )
                    }}
                </Formik>
            </ModalBody>
        </Modal>
        </>
    );
}